export default __webpack_public_path__ + "static/media/anambra-frame.4c8fc9c4.png";